const palette = {
    // Primary
    plum: '#631B3A',
    black: '#000000',
    white: '#FFFFFF',
    // Supporting
    // Yellows
    sunflower: '#FFED4E',
    olive_green: '#7D6F05',
    sunbeam: '#FCF29B',
    // Greens
    seaglass_green: '#64EDBB',
    dark_cyan: '#2C667D',
    powder_blue: '#9FBBC5',
    mint_green: '#DBF9EE',
    // Blues
    pacific_blue: '#479BFF',
    cobalt_night: '#4855A7',
    pale_blue: '#EDF1FC',
    // Purples
    electric_lilac: '#8D5FFF',
    lavender_gray: '#A79AB8',
    // pale_lavender,
    // Reds
    coral: '#FF4A80',
    // plum
    dusty_rose: '#B75781',
    rose: '#DBABC0',
    // UI
    powder_black: '#080b0d',
};

export { palette };
